export function ordinal(n: number, language: string): string {
  const lang = language.split('-')[0]

  // Romanian: no ordinal suffix — "locul 32"
  if (lang === 'ro') return String(n)

  // French: feminine ordinal for "place" — "1re", "2e", "32e"
  if (lang === 'fr') return n === 1 ? '1re' : `${n}e`

  // English (default): 1st, 2nd, 3rd, 32nd, ...
  const s = ['th', 'st', 'nd', 'rd']
  const v = n % 100
  return n + (s[(v - 20) % 10] ?? s[v] ?? s[0])
}

export function RankBadge({ rank }: { rank: number }) {
  if (rank === 1) return <span className="text-base font-bold text-yellow-500">🥇</span>
  if (rank === 2) return <span className="text-base font-bold text-foreground/60">🥈</span>
  if (rank === 3) return <span className="text-base font-bold text-amber-600">🥉</span>
  return (
    <span className="whitespace-nowrap text-sm font-semibold tabular-nums text-foreground/70">
      #{rank}
    </span>
  )
}

export function AvatarPlaceholder({ name }: { name: string }) {
  const initial = name.charAt(0).toUpperCase()
  return (
    <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-content3 text-xs font-bold text-foreground/60">
      {initial}
    </div>
  )
}
